<template>
  <div class="column is-12">
            <!----------- subtitle ---------------------------------->
            <div class="field">
              <label class="label">{{ elLabel }}</label>
              <div class="control">
                <input 
                maxlength="1000"
                class="input" 
                type="text" 
                :value="data"
                @input="$emit('wasUpdated', $event.target.value)"
                name="subtitle">
              </div>
            </div>
</div>
</template>

<script>
export default {
  // inject: ['$validator'],
  props: ['data', 'elLabel'],
  data () {
    return {
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Subtitle.vue